export const wrapWithElement = (html, elementTag, cssClass) => {
    return `<${elementTag} class="${cssClass}">${html}</${elementTag}>`;
};
//# sourceMappingURL=wrap-with-element.js.map